import "./index.scss";

import { Box, Stack } from "@mui/material";
import CapsuleText from "components/CapsuleText";
import TitleWithOptions from "components/TitleWithOptions";
import { EXERCISE_READINESS_QUESTIONS_AND_ANSWERS } from "constants/index";
import { TMemberDetails } from "models/member";
import { useEffect, useState } from "react";
import React from "react";

const ExerciseHealthComp = (props: {
  member: TMemberDetails;
  editCallback: Function;
  canShowExerciseReadiness: boolean;
  canShowHealthCondition: boolean;
}) => {
  const { member, editCallback, canShowExerciseReadiness, canShowHealthCondition } = props;
  const [exerciseSectionVisibile, setExerciseSectionVisible] = useState(false);
  const [healthConditionsSectionVisibile, setHealthConditionsSectionVisible] = useState(false);
  const [groupedHealthConditions, setGroupedHealthConditions] = useState<{
    [key: string]: any[];
  }>({});

  useEffect(() => {
    if (member?.exercise_readiness.length > 0 && canShowExerciseReadiness) {
      setExerciseSectionVisible(true);
    }
    if (member?.health_conditions.length > 0 && canShowHealthCondition) {
      setHealthConditionsSectionVisible(true);
      const tempGroupedHealthConditions = member?.health_conditions?.reduce((groups, item) => {
        const group = groups[item.category] || [];
        group.push(item);
        groups[item.category] = group;
        return groups;
      }, {});
      setGroupedHealthConditions(tempGroupedHealthConditions);
    }
  }, [member]);

  const callback = (v: string) => {
    editCallback(v);
  };

  if (!exerciseSectionVisibile && !healthConditionsSectionVisibile) return null;

  return (
    <Box className="exercise-health-container" display="flex" flexDirection="row">
      {exerciseSectionVisibile && (
        <Stack flex={1}>
          <TitleWithOptions
            title="Exercise Readiness"
            edit={() => callback("exercise_readiness")}
          />
          <Box className="section-inner-container" display="flex" flexDirection="column">
            {member?.exercise_readiness.map((m, i) => (
              <CapsuleText
                key={`exerciseReadiness${i}`}
                text={
                  EXERCISE_READINESS_QUESTIONS_AND_ANSWERS.find((f) => f.question === m.health_info)
                    .answer
                }
              />
            ))}
          </Box>
        </Stack>
      )}
      {healthConditionsSectionVisibile && (
        <Stack flex={1}>
          <TitleWithOptions title="Health Conditions" edit={() => callback("health_conditions")} />
          <Box className="section-inner-container" display="flex" flexDirection="column" gap={2}>
            {Object.keys(groupedHealthConditions).map((m, i) => (
              <React.Fragment key={`groupedHealthCondition${i}`}>
                <p className="title">{m}</p>
                {groupedHealthConditions[m].map((n, index) => (
                  <CapsuleText key={`healthCondition_${i}_${index}`} text={n.health_info} />
                ))}
              </React.Fragment>
            ))}
          </Box>
        </Stack>
      )}
    </Box>
  );
};

export default ExerciseHealthComp;
